export default {
    meta: {
        title: '新增加盟商',
        url: '/standardstore/franchiseelist',
        urlName: '标准版拓店-加盟商',
    }
};
